/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import cookies from 'react-cookies';
import { FaWindows } from 'react-icons/fa';
import { NavLink, useHistory } from 'react-router-dom';
import BackButton from '../BackButton';
import { Content, Menu, Left, Banner, Right, Buttons } from './styles';

const Header: React.FC = () => {
  return (
    <Content>
      <Menu>
        <Left>
          <NavLink exact to="/">
            <Banner>
              <h1>Stone GPS</h1>
              <h4>Gestão de Pagamentos Stone</h4>
            </Banner>
          </NavLink>
        </Left>
        <Right>
          <Buttons>
            {cookies.load('external_tags') ? (
              cookies.load('external_tags').gps_recebedor ? (
                <NavLink
                  to="/newcontract"
                  onClick={() => {
                    localStorage.removeItem('proposalInfoClient');
                  }}
                >
                  Nova Proposta
                </NavLink>
              ) : cookies.load('external_tags').gps_originador ? (
                <div />
              ) : (
                <div />
              )
            ) : (
              <div />
            )}
          </Buttons>
        </Right>
      </Menu>
    </Content>
  );
};

export default Header;
